import React, { Component } from "react";
import "./MapMadlan.scss";
import { usingAPI } from "../Services/FetchService";
export default class MapMadlan extends Component {
    constructor() {
        super();
        this.state = {
        }
    }
    render() {
        return (
            <section className="section section-madlan">
                <div className="padding">
                    <div className="container">
                        <div className="headline">
                        </div>
                        <div className="latest">
                            <div className="wrapper">
                                <iframe src="https://elections2020.madlan.co.il"
                                    width="100%"
                                    frameBorder="0" scrolling="no"></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Components/MapMadlan/MapMadlan.jsx